import "core-js/modules/es.array.push.js";
import { customerList, data, tableData } from './partten';
// import {customerList} from './../../system/customerManage/request';
import { workersList, structureList } from './../../organization/staffManage/request';
import { postResource } from './../../organization/postManage/request';
export default {
  data() {
    return {
      customerList,
      filterText: '',
      postList: [],
      form: {
        customerId: '',
        structureId: 0,
        postId: undefined
      },
      data,
      // data:[],//树结构
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      tableData,
      // tableData:[],
      tableHead: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80,
        align: 'center'
      }, {
        slots: {
          title: '工号'
        },
        dataIndex: 'jobNo',
        key: '1',
        align: 'center'
      }, {
        slots: {
          title: '姓名'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      },
      // {title: '职级',  dataIndex: 'postName', key: '3',align: 'center'},
      {
        slots: {
          title: '人员状态'
        },
        dataIndex: 'statusName',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '部门'
        },
        dataIndex: 'structureName',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 350,
        key: '6'
      }],
      resourceList: []
    };
  },
  created() {
    this.form.customerId = this.customerList[0].id;
    this.$nextTick(() => {
      // 默认高亮选中节点
      this.$refs.tree.setCurrentKey(this.data[0].id);
    });
    // customerList({page:1,pageSize:10000}).then(res=>{
    //   this.customerList=res.items;
    //   let arr =this.customerList.filter(item=>item.id==Number(sessionStorage.getItem('customerId')));
    //   this.form.customerId=arr.length!=0?Number(sessionStorage.getItem('customerId')):res.items[0].id;
    //   sessionStorage.setItem('customerId',this.form.customerId);
    //   this.getStructure();
    //   this.getDataFun();
    //   this.getPostFun();
    // });
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    customerIdFun(e) {
      sessionStorage.setItem('customerId', e);
      this.form.structureId = 0;
      this.form.postId = undefined;
      this.getDataFun();
      this.getStructure();
      this.getPostFun();
    },
    getPostFun() {
      postResource({
        customerId: this.form.customerId
      }).then(res => {
        this.postList = res;
      });
    },
    getStructure() {
      structureList({
        customerId: this.form.customerId
      }).then(res => {
        // let name=this.customerList.filter(item=>item.id==Number(this.form.customerId))[0].name
        this.data = res;
        this.$nextTick(() => {
          // 默认高亮选中节点
          this.$refs.tree.setCurrentKey(this.data[0].id);
        });
      });
    },
    handleNodeClick(data) {
      console.log(data);
      this.form.structureId = data.id;
      // this.getDataFun();
    },
    getDataFun() {
      let obj = this.form;
      Object.assign(obj, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      });
      workersList(obj).then(res => {
        this.tableData = res.items || [];
        this.pagination.total = res.totalNum;
      });
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleAdd() {
      if (!this.form.structureId) {
        this.$message.error(this.$t('请选择') + this.$t('部门再进行新增操作'));
      } else {
        this.$router.push({
          name: 'salesmanStaffManageHome',
          params: {
            id: -1,
            type: -1,
            structure: this.form.structureId,
            customerId: this.form.customerId
          }
        });
      }
    }
  }
};